import { Component, Input, OnChanges, SimpleChanges, ViewChildren, QueryList } from '@angular/core';

import { ApiError, MessageService, notCloseMessageOptions } from '../../../../../core';
import { ClienteUnidadeNegocioSearchNaturezaVenda } from './cliente-unidade-negocio-search-natureza-venda';
import { UnidadeNegocioNaturezaVenda, UnidadeNegocioNaturezaVendaFilter, UnidadeNegocioNaturezaVendaHttpService } from '../../../../unidade-negocio/natureza-venda';
import { naturezaVendaAtiva, naturezaVendaInativa } from '../../../../natureza-venda';
import { ItemTipo } from '../../../../item-tipo';
import { ClienteUnidadeNegocioItemTipoComponent } from '../item-tipo';

@Component({
    selector: 'sgt-cliente-unidade-negocio-natureza-venda',
    templateUrl: './cliente-unidade-negocio-natureza-venda.component.html',
    styleUrls: ['./cliente-unidade-negocio-natureza-venda.component.less']
})
export class ClientUnidadeNegocioNaturezaVendaComponent implements OnChanges {
    @Input() canEdit = true;
    /** ID do cliente */
    @Input() idCliente: number;

    /** ID da unidade de negócio */
    @Input() idUnidadeNegocio: number;
    /** Nome da unidade de negócio */
    @Input() nomeUnidadeNegocio: string;
    /** Index da unidade de negócio */
    @Input() indexUnidadeNegocio: number;

    /** ID do mercado */
    @Input() idMercado: number;
    /** Nome do mercado */
    @Input() nomeMercado: string;
    /** Index do mercado */
    @Input() indexMercado: number;

    @Input() itensTipos: ItemTipo[] = [];

    /** Naturezas de vendas */
    @Input() entities: ClienteUnidadeNegocioSearchNaturezaVenda[];

    /** Naturezas de vendas vinculadas na unidade de negócio */
    naturezasVendas: UnidadeNegocioNaturezaVenda[];
    naturezaVendaSituacaoAtiva = naturezaVendaAtiva.id;
    naturezaVendaSituacaoInativa = naturezaVendaInativa.id;

    /** Forms dos tipos de itens */
    @ViewChildren('itemTipoForm') itensTiposForms: QueryList<ClienteUnidadeNegocioItemTipoComponent>;


    constructor(private messageService: MessageService,
                private unidadeNegocioNaturezaVendaHttpService: UnidadeNegocioNaturezaVendaHttpService) { }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'idUnidadeNegocio') {
                // Se possuir o ID da Unidade de Negócio selecionado então pesquisamos as naturezas de vendas vinculadas a esta Unidade de Negócio
                if (this.idUnidadeNegocio) {
                    this.searchNaturezasVendas(this.idUnidadeNegocio);
                } else {
                    this.naturezasVendas = [];
                }
            }
        }
    }

    /** Pesquisas naturezas de vendas ativas vinculadas na unidade de negócio */
    private searchNaturezasVendas(idUnidadeNegocio: number) {
        const filter = new UnidadeNegocioNaturezaVendaFilter()
        this.unidadeNegocioNaturezaVendaHttpService.search(idUnidadeNegocio, filter)
            .subscribe(
                naturezasVendas => this.naturezasVendas = naturezasVendas,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as naturezas de vendas', error)
            );
    }

    insert() {
        if (!this.canEdit) {
            return;
        }
        const entity = new ClienteUnidadeNegocioSearchNaturezaVenda();
        this.entities.push(entity);
    }

    delete(index: number) {
        if (index < 0 || !this.canEdit) {
            return;
        }

        const entity = this.entities[index];
        this.messageService.confirm(`Deseja realmente remover a natureza de venda ${entity?.nomeNaturezaVenda ?? ''} do mercado ${this.nomeMercado ?? ''} e unidade de negócio ${this.nomeUnidadeNegocio ?? ''}?`, 'Confirme').then(result => {
            if (result) {
                this.entities.splice(index, 1);
            }
        });
    }

    /** Ao selecionar a natureza de venda */
    onSelectNaturezaVenda(entity: ClienteUnidadeNegocioSearchNaturezaVenda, idNaturezaVenda: number) {
        if (idNaturezaVenda) {
            entity.idNaturezaVenda = idNaturezaVenda;

            const unidadeNegocioNaturezaVenda = this.naturezasVendas?.find(naturezaVendaFilter => naturezaVendaFilter.idNaturezaVenda === idNaturezaVenda);
            entity.nomeNaturezaVenda = unidadeNegocioNaturezaVenda?.naturezaVenda?.nome ?? null;
            entity.situacaoNaturezaVenda = unidadeNegocioNaturezaVenda?.naturezaVenda?.situacao ?? null;
        } else {
            entity.idNaturezaVenda = null;
            entity.nomeNaturezaVenda = null;
            entity.situacaoNaturezaVenda = null;
        }
    }

    /** Verifica se as naturezas de vendas estão válidas */
    isValid(): boolean {
        if (!this.canEdit) {
            return true;
        }

        // Verificando se os tipos de itens estão válidos
        let isClientesItensTiposValid = true
        this.itensTiposForms?.forEach(itemTipoForm => {
            if (!itemTipoForm.isValid()) {
                isClientesItensTiposValid = false;
            }
        });
        if (!isClientesItensTiposValid) {
            return false;
        }

        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];
            if (!entity.idNaturezaVenda) {
                continue;
            }

            const count = this.entities.filter(entityFilter => entityFilter.idNaturezaVenda && entityFilter.idNaturezaVenda === entity.idNaturezaVenda).length;
            if (count > 1) {
                this.messageService.warning(`A natureza de venda ${entity.nomeNaturezaVenda ?? ''} já está adicionada no mercado ${this.nomeMercado ?? ''} e unidade de negócio ${this.nomeUnidadeNegocio ?? ''}. Remova ou altere a natureza de venda duplicada`, 'Não é possível adicionar duas naturezas de vendas iguais no mesmo mercado e unidade de negócio', notCloseMessageOptions);
                return false;
            }
        }
        return true;
    }
}
